import * as Yup from "yup";
export const initialFilterStateDiagnostic = {
  page: 1,
  rows: 10,
  isActive: "",
  diagnosticCategory: "",
  sortDirection: "DESC",
  type:""
};
export const initialFilterStateTestCreation = {
  page: 1,
  rows: 10,
  diagnosticCategoryId: 0,
  testId: 0,
  testName: "",
  BusinessType: null,
  isActive: null,
  sortDirection: "",
  sortColumn: "",
  type:""
};

export const initialFilterStateParameterCreation = {
  TestParameterName: "",
  isActive: null,
  testId: 3,
  page: 1,
  rows: 10,
  sortDirection: "",
  sortColumn: "",
};

export const YUPValidations = Yup.object().shape({
  diagnosticCategory: Yup.string()
    .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
});
export const YUPValidationsParameter = Yup.object().shape({
  testParameterName: Yup.string()
    .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
});

export const YUPValidationsServiceCreation = Yup.object().shape({
  // facilityTypeId: Yup.string(/^[A-Za-z ]*$/)
  //   .nullable()
  //   .required("Field is required"),
  facilityCategoryId: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
    facilityId: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
    testName: Yup.string()
    .test(
      "no-words",
      "Test name cannot have age, gender, visit type",
      (value) => {
        // List of words to check for
        const wordsToCheck = [
          "male",
          "female",
          "year",
          "center visit",
          "centre visit",
          "centrevisit",
          "homevisit",
          "centervisit",
          "years",
          "visit",
          "age",
          "yrs",
          "home visit",
        ];
        const wordPattern = new RegExp(
          `\\b(${wordsToCheck.join("|")})\\b`,
          "i"
        );
        return !wordPattern.test(value);
      }
    )
    .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  displayName: Yup.string()
    .test(
      "no-words",
      "Test name cannot have age, gender, visit type",
      (value) => {
        // List of words to check for
        const wordsToCheck = [
          "male",
          "female",
          "year",
          "center visit",
          "centre visit",
          "centrevisit",
          "homevisit",
          "centervisit",
          "years",
          "visit",
          "age",
          "yrs",
          "home visit",
        ];
        const wordPattern = new RegExp(
          `\\b(${wordsToCheck.join("|")})\\b`,
          "i"
        );
        return !wordPattern.test(value);
      }
    )
    .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  hvChargesId: Yup.string(),
  // .when("isHomeVisitAllowed", {
  //   is: true,
  //   then: Yup.string().required("Field is required"),
  //   otherwise: Yup.string(),
  // }),
  isHomeVisitAllowed: Yup.boolean(),
  packageTaggingId: Yup.string(/^[A-Za-z ]*$/)
    .nullable(),
    // .test("not-zero", "Field is required", (value) => value !== "0"),
    testTypeId: Yup.string(/^[A-Za-z ]*$/)
    .nullable(),
  gender: Yup.string(/^[A-Za-z ]*$/)
    .nullable(),
  finalReporting: Yup.string(/^[A-Za-z ]*$/)
    .nullable(),
  isProfile: Yup.string(/^[A-Za-z ]*$/)
    .nullable(),
  isFastingRequired: Yup.string(/^[A-Za-z ]*$/)
    .nullable(),
  isMERAttachmentRequired: Yup.string(/^[A-Za-z ]*$/)
    .nullable(),
  isDisabledForPregnancy: Yup.string(/^[A-Za-z ]*$/)
    .nullable(),
  synonyms: Yup.string()
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  description: Yup.string()
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  minAge: Yup.number()
    .nullable()
    .typeError("The field should have digits only")
    .max(Yup.ref("maxAge"))
    .moreThan(0, "Min Age should be greater than zero"),
  maxAge: Yup.number()
    .nullable()
    .typeError("The field should have digits only")
    .moreThan(0, "Max Age should be greater than zero"),
});
export const YUPValidationsTestCreation = Yup.object().shape({
  facilityTypeId: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  facilityCategoryId: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  testName: Yup.string()
    .test(
      "no-words",
      "Test name cannot have age, gender, visit type",
      (value) => {
        // List of words to check for
        const wordsToCheck = [
          "male",
          "female",
          "year",
          "center visit",
          "centre visit",
          "centrevisit",
          "homevisit",
          "centervisit",
          "years",
          "visit",
          "age",
          "yrs",
          "home visit",
        ];
        const wordPattern = new RegExp(
          `\\b(${wordsToCheck.join("|")})\\b`,
          "i"
        );
        return !wordPattern.test(value);
      }
    )
    .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  displayName: Yup.string()
    .test(
      "no-words",
      "Test name cannot have age, gender, visit type",
      (value) => {
        // List of words to check for
        const wordsToCheck = [
          "male",
          "female",
          "year",
          "center visit",
          "centre visit",
          "centrevisit",
          "homevisit",
          "centervisit",
          "years",
          "visit",
          "age",
          "yrs",
          "home visit",
        ];
        const wordPattern = new RegExp(
          `\\b(${wordsToCheck.join("|")})\\b`,
          "i"
        );
        return !wordPattern.test(value);
      }
    )
    .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  hvChargesId: Yup.string().when("isHomeVisitAllowed", {
    is: true,
    then: Yup.string().required("Field is required"),
    otherwise: Yup.string(),
  }),
  isHomeVisitAllowed: Yup.boolean().required("Field is required"),
  packageTaggingId: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .test("not-zero", "Field is required", (value) => value !== "0")
    .required("Field is required"),
  testTypeId: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  gender: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  finalReporting: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  isProfile: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  isFastingRequired: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  isMERAttachmentRequired: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  isDisabledForPregnancy: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  synonyms: Yup.string()
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  description: Yup.string()
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  minAge: Yup.number()
    .nullable()
    .typeError("The field should have digits only")
    .max(Yup.ref("maxAge"))
    .moreThan(0, "Min Age should be greater than zero"),
  maxAge: Yup.number()
    .nullable()
    .typeError("The field should have digits only")
    .moreThan(0, "Max Age should be greater than zero"),
});

export const trimInputHandler = (e, setValue) => {
  const inputValue = e.target.value;
  const trimmedValue = inputValue.trim();

  // Check if the trimmed value is not empty
  if (trimmedValue !== "") {
    // There is some non-empty text or numbers
    setValue(inputValue);
  } else {
    // The textarea is empty or only contains blank spaces
    setValue("");
  }
};

export const tableHeaderTestCreation = [
  { name: "Test Name" },
  { name: "Facility Type" },
  { name: "Profile" },
  { name: "Agreed Rate" },
  { name: "Fasting Required" },
  { name: "HV Charges For" },
  { name: "Active For IBU" },
  { name: "Active For CBU" },
];
export const tableHeaderServiceCreation = [
  { name: "SKU Name" },
  { name: "Facility Type" },
  { name: "Profile" },
  { name: "Agreed Rate" },
  { name: "Fasting Required" },
  { name: "HV Charges For" },
  { name: "Active For IBU" },
  { name: "Active For CBU" },
];

export const tableHeaderParameterCreation = [
  { name: "Parameter Name" },
  { name: "HV Charges For" },
  { name: "Fasting Required" },
  { name: "Home Visit" },
  { name: "Active" },
];
